export {Tabs} from 'antd';
export type {TabsProps} from 'antd/es/tabs/index';
